import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import axios from "axios";

export const AgregarReten = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtIdReten = useRef();
  const txtTipo = useRef();
  const txtNintru = useRef();
  const txtFechaem = useRef();
  const txtNombres = useRef();
  const txtCedularif = useRef();
  const txtMontobruto = useRef();
  const txtImpuesto = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [total, setTotal] = useState(0.0);
  const [divide, setDivide] = useState({
    tipo: "1",
    signo: "/",
    valor: 1000,
  });
  const [values, setValues] = useState({
    idretenciontemp: "",
    fechaemision: "",
    agenteretencion: "",
    nomcontribuyente: "",
    tipo: "",
    rif: "",
    periodo: "",
    numcontrol: "",
    montobruto: 0.0,
    montoretenido: 0.0,
  });

  const onChange = (event) => {
    if (
      event.target.name === "fecha" ||
      event.target.name === "nomcontribuyente" ||
      event.target.name === "rif" ||
      event.target.name === "tipo" ||
      event.target.name === "numcontrol"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }

    if (event.target.name === "1x500") {
      let monto = 0.0;
      let totalValor = 0.0;

      monto = parseFloat(
        txtMontobruto.current.value !== ""
          ? txtMontobruto.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", ".")
          : 0.0
      );

      if (event.target.value === "1") {
        totalValor = monto / 1000;
        setDivide({
          tipo: "1",
          signo: "/",
          valor: 1000,
        });
      } else if (event.target.value === "2") {
        totalValor = monto / 500;
        setDivide({
          tipo: "2",
          signo: "/",
          valor: 500,
        });
      } else if (event.target.value === "3") {
        totalValor = monto * 0.01;
        setDivide({
          tipo: "3",
          signo: "*",
          valor: 0.01,
        });
      }

      txtImpuesto.current.value = formatMoneda(
        totalValor.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtTipo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Tipo de Instrumento",
        icono: "informacion",
      });
      sigue = false;
      txtTipo.current.focus();
    } else if (txtNintru.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el N° de Instrumento",
        icono: "informacion",
      });
      sigue = false;
      txtNintru.current.focus();
    } else if (txtCedularif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Número de Cédula o RIF",
        icono: "informacion",
      });
      sigue = false;
      txtCedularif.current.focus();
    } else if (txtNombres.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre o Razón Social del Contribuyente",
        icono: "informacion",
      });
      sigue = false;
      txtNombres.current.focus();
    } else if (txtFechaem.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Emisión",
        icono: "informacion",
      });
      sigue = false;
      txtFechaem.current.focus();
    } else if (txtMontobruto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introdusca el Monto Bruto",
        icono: "informacion",
      });
      sigue = false;
      txtMontobruto.current.focus();
    } else if (txtMontobruto.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto Bruto no puede ser 0,00",
        icono: "informacion",
      });
      sigue = false;
      txtMontobruto.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/retencion/actualizarretenciontemp/${props.operacion}`;
    let body;
    setActivate(true);

    body = {
      idretentemp: parseInt(txtIdReten.current.value),
      txtagente: props.agente,
      txtfechac: txtFechaem.current.value,
      txttipo: txtTipo.current.value.trim(),
      txtcontrol: txtNintru.current.value.trim(),
      //txtbanco: txtBanco.current.value.trim(),
      //txtreferencia: txtReferencia.current.value.trim(),
      txtbanco: "null",
      txtreferencia: "null",
      txtrif: txtCedularif.current.value,
      txtrazon: txtNombres.current.value.trim(),
      txtmontob: parseFloat(
        txtMontobruto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      txtperiodo: props.periodo.padStart(7, "0"),
      txtretenido: parseFloat(
        txtImpuesto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      onCalculo();
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      idretenciontemp: "",
      fechaemision: "",
      agenteretencion: "",
      //banco: "",
      //referencia: "",
      nomcontribuyente: "",
      tipo: "",
      rif: "",
      periodo: "",
      numcontrol: "",
      montobruto: 0.0,
      montoretenido: 0.0,
    });
    setOperacion(0);
    setTotal(0.0);
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const onCalculo = () => {
    console.log("pase");
    let monto = 0.0;
    let totalValor = 0.0;

    monto = parseFloat(
      txtMontobruto.current.value !== ""
        ? txtMontobruto.current.value
            .trim()
            .replace(/\./g, "")
            .replace(",", ".")
        : 0.0
    );

    if (divide.tipo === "1") {
      totalValor = monto / divide.valor;
    } else if (divide.tipo === "2") {
      totalValor = monto / divide.valor;
    } else if (divide.signo === "3") {
      totalValor = monto * divide.valor;
    }

    txtImpuesto.current.value = formatMoneda(
      totalValor.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  useEffect(() => {
    //SeleccionarRegistros();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        console.log(props.retencion);
        if (props.operacion !== 1) {
          setValues(props.retencion);

          let montob = 0.0,
            montot = 0.0;

          montob = props.retencion.montobruto;
          montot = props.retencion.montoretenido;

          txtMontobruto.current.value = formatMoneda(
            montob.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtImpuesto.current.value = formatMoneda(
            montot.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Retención."
            : props.operacion === 2
            ? "Editar Retención."
            : props.operacion === 3
            ? "Eliminar Retención."
            : "Consultar Retención."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "65vh", overflow: "auto" }}>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded mx-auto">
              <div className="card bg-gradient-light">
                <div className="card-header">
                  <h5 className="card-title">Datos de la Retención</h5>
                </div>
                <div className="card-body">
                  <div className="rounded border border-info py-3">
                    <div className="col-md-12 mx-auto">
                      <h5 className="text-center">Datos Agente Retenido</h5>
                      <hr style={{ backgroundColor: "#008080" }} />
                    </div>
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-sm-3">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          N° de Operación:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled={true}
                          maxLength="10"
                          name="idretenciontemp"
                          id="NumIntru"
                          ref={txtIdReten}
                          value={values.idretenciontemp}
                          onChange={onChange}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-5">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Tipo de Instrumento:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtTipo}
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          name="tipo"
                          value={values.tipo}
                          placeholder="Tipo de Instrumento"
                          onChange={onChange}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          N° de Instrumento:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          /*       maxLength="10" */
                          name="numcontrol"
                          id="NumIntru"
                          value={values.numcontrol}
                          placeholder="Número"
                          ref={txtNintru}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <hr className="col-sm-11 py-0 px-2 mx-auto container text-success2" />
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-md-3">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Cedula/RIF:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          maxLength="12"
                          name="rif"
                          id="rif"
                          ref={txtCedularif}
                          value={values.rif}
                          placeholder="Cédula o RIF"
                          onChange={onChange}
                        />
                      </div>

                      <div className="input-group input-group-sm col-sm-9">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Nombre o Razón Social:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtNombres}
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          name="nomcontribuyente"
                          onChange={onChange}
                          value={values.nomcontribuyente}
                          placeholder="Nombre o Razón Social"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 row py-2">
                      <div className="input-group input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Fecha de Emisión:
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtFechaem}
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          defaultValue={
                            values && values.fechaemision
                              ? moment(values.fechaemision).format("YYYY-MM-DD")
                              : ""
                          }
                          name="fechaemision"
                          onChange={onChange}
                        />
                      </div>

                      <div className="input-group input-group-sm col-md-3">
                        <label
                          className="input-group-text"
                          style={{ backgroundColor: "#55acee" }}
                          id="inputGroup-sizing-sm"
                        >
                          Monto Bruto:
                        </label>
                        <input
                          type="text"
                          className="form-control text-right col-md-7"
                          aria-describedby="validationTooltipMinimo"
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          maxLength="20"
                          name="montobruto"
                          id="montobruto"
                          ref={txtMontobruto}
                          onFocus={seleccionarCampo}
                          defaultValue={
                            values && values.montobruto
                              ? formatMoneda(
                                  values.montobruto
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                          }
                          onBlur={handleInputMontoChange}
                          onKeyUp={handleInputMontoChange}
                          placeholder="0,00"
                          required
                        />
                      </div>

                      <div className="input-group input-group-sm col-md-5">
                        <select
                          className="form-select text-center"
                          name="1x500"
                          style={{
                            backgroundColor: "#ee5555",
                            color: "#ffffff",
                            fontWeight: "bold",
                          }}
                          value={divide.tipo}
                          onChange={onChange}
                        >
                          <option value="1">Impuesto 1x1000</option>
                          <option value="2">Impuesto 1x500</option>
                          <option value="3">1% Obras</option>
                        </select>
                        <input
                          type="text"
                          className="form-control text-right col-md-7"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          disabled={true}
                          maxLength="10"
                          name="impuesto"
                          id="impuesto"
                          ref={txtImpuesto}
                          defaultValue={formatMoneda(
                            total.toString().replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/modalAgregarReten.js